import script from "./StepOrdering.vue?vue&type=script&setup=true&lang=js"
export * from "./StepOrdering.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NumberStepper from "@/components/neue/wizard/NumberStepper.vue";
import PillRadioGroup from "@/components/neue/wizard/PillRadioGroup.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import SelectionCard from "@/components/neue/wizard/SelectionCard.vue";
import SelectionGroup from "@/components/neue/wizard/SelectionGroup.vue";
import TextWithHint from "@/components/neue/wizard/TextWithHint.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { NumberStepper, PillRadioGroup, SelectInput, SelectionCard, SelectionGroup, TextWithHint, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NumberStepper, PillRadioGroup, SelectInput, SelectionCard, SelectionGroup, TextWithHint, WizardSection }, script.__o.components);}